import { __extends } from "tslib";
import React from 'react';
import s from '../solution-rate-reviews.scss';
import { Text, Box, TextButton } from 'wix-style-react';
import { composer } from '../../../../../component-decorators/composer';
var ReviewBody = /** @class */ (function (_super) {
    __extends(ReviewBody, _super);
    function ReviewBody(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isLongReview: _this.isBodyTooLong(props.body),
            expandedBody: false,
        };
        _this.getReviewBodyText = _this.getReviewBodyText.bind(_this);
        _this.expandToggle = _this.expandToggle.bind(_this);
        return _this;
    }
    ReviewBody.prototype.isBodyTooLong = function (body) {
        return body && body.split(' ').length > 34;
    };
    ReviewBody.prototype.getReviewBodyText = function () {
        return this.state.isLongReview && !this.state.expandedBody
            ? reviewBodySlicer(this.props.body)
            : this.props.body;
    };
    ReviewBody.prototype.expandToggle = function () {
        this.setState(function (prevState) {
            return {
                expandedBody: !prevState.expandedBody,
            };
        });
    };
    ReviewBody.prototype.render = function () {
        return (React.createElement(Box, { marginBottom: this.props.isMobile ? "0px" : "5" },
            !this.props.isMobile && React.createElement(Box, { width: "55px" }),
            React.createElement(Box, { direction: "vertical", marginLeft: "2" },
                this.props.title ? (React.createElement(Text, { size: "medium", weight: "bold" }, this.props.title)) : null,
                React.createElement(Text, { property: "reviewBody", dataHook: "review-" + (this.props.id && this.props.id), className: s.reviewBody, size: "medium" }, this.getReviewBodyText()),
                this.state.isLongReview && (React.createElement(TextButton, { dataHook: "review-body-expander-" + this.props.id, onClick: this.expandToggle }, this.state.expandedBody ? (React.createElement(TranslatedKey, { tkey: 'solution.page.review.readLess' })) : (React.createElement(TranslatedKey, { tkey: 'solution.page.review.readMore' })))))));
    };
    return ReviewBody;
}(React.Component));
export { ReviewBody };
export var reviewBodySlicer = function (body) {
    return (body
        .split(' ')
        .slice(0, 33)
        .map(function (word) { return word + ' '; })
        .reduce(function (a, b) { return a + b; }, '')
        .replace(/\s*$/, '') + '...');
};
var TranslatedKey = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, tkey = _a.tkey;
    return t(tkey);
});
//# sourceMappingURL=solution-review-body.js.map